import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as Employees from '../components';
import EmployeeFormHandlers from './EmployeeFormHandlers';

import {
  getIsSaving,
  getIsFetching,
  getEditing,
  getVisibleCustomFieldsEmployees,
  getIsFetchingConfig,
} from '../selectors';
import { getCompany, getSubcompany } from 'auth/selectors';

class EmployeesFormContainer extends Component {
  render = () => (
    <EmployeeFormHandlers
      render={({
        handleAddYear,
        handleRemoveYear,
        handleSubmit,
        handleValidation,
        handleValueChange,
        handleDependentChange,
        handleAddCustomField,
        handleRemoveCustomField,
        isSubmitted,
        isSaving,
      }) => {
        return (
          <Employees.FormView
            company={this.props.company}
            employee={this.props.employee}
            customs={this.props.customs}
            handleAddYear={handleAddYear}
            handleRemoveYear={handleRemoveYear}
            handleSubmit={handleSubmit}
            handleValidation={handleValidation}
            handleValueChange={handleValueChange}
            handleDependentChange={handleDependentChange}
            handleAddCustomField={handleAddCustomField}
            handleRemoveCustomField={handleRemoveCustomField}
            isFetching={this.props.isFetching}
            isSubmitted={isSubmitted}
            isSaving={isSaving}
            subcompany={this.props.subcompany}
          />
        );
      }}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  employee: getEditing(state),
  customs: getVisibleCustomFieldsEmployees(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(EmployeesFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/containers/EmployeeFormContainer.js